export enum SalesRegionCodes {
  SCANDINAVIA = "2",
  THEBALTICSANDCIS = "6",
  WESTERNEUROPE = "7",
  CENTRALEUROPE = "8",
  UKANDROI = "9",
  POLAND = "10",
}
